export type UseInfoBoxOutput = {
  handleBtnClose: () => void;
};

export const useInfoBox = ({
  onClose,
}: {
  onClose?: () => void;
}): UseInfoBoxOutput => {
  const handleBtnClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return {
    handleBtnClose,
  };
};
